export default __webpack_public_path__ + "static/media/Game2048.b0512e85.png";